<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.cdn + '/images/map/blackhole.webp'"
    :toast-text="t('news.types.portalFound.title')"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="gameStore.cdn + '/images/map/blackhole.webp'"
        :header="t('news.types.portalFound.title')"
      >
        <div class="flex flex-col justify-between h-full">
          <div class="flex-grow h-7 overflow-hidden text-ellipsis custom-line-clamp mb-1">
            {{ t('news.types.portalFound.body') }}
          </div>
        </div>
      </NewsItemBaseStructure>
  </NewsItemBase>

</template>

<style scoped lang="scss">
.custom-line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 5; /* Limit to 5 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

</style>